/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExecuteUserOpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {ExecuteUserOpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const executeUserOp = (request: ExecuteUserOpRequest, options?: CashRequestOptions) => post<ExecuteUserOpRequest, ExecuteUserOpResponse>("/2.0/cash/execute-user-op", request, {...options, rejectOnError: true })